<template>
  <el-dialog
    append-to-body
    width="550px"
    title=""
    destroy-on-close
    :visible.sync="visible"
    :before-close="reset"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    v-loading="loading"
    element-loading-text="图片上传中…"
  >
    <template #title>
      <div class="el-dialog-title">添加评论</div>
    </template>
    <el-form
      class="staff-from"
      ref="elFormDom"
      label-width="80px"
      label-position="top"
      :model="form.data"
      :rules="form.rules"
      :size="subUnitSize"
      hide-required-asterisk
    >
      <aiTe ref="aiTeRef" v-model="aiteIdList" @change="aiTeChange"></aiTe>
      <div :class="{'padding-b10':aiteObjList.length}">
        <el-tag size="small" v-for="tag in aiteObjList" @close="tagClose(tag.id)" :key="tag.name" closable>
          {{ tag.name }}
        </el-tag>
      </div>
      <el-form-item label="" prop="comment">
        <el-input
          type="textarea"
          :autosize="{ minRows: 4, maxRows: 8 }"
          v-model.trim="form.data.comment"
          placeholder="请输入评论内容"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="附件" prop="file">
        <template #label>
          附件 <span style="color: #999"></span>
          <uploadfile
            :loading.sync="form.loading"
            :fileList="fileList"
            @setfileList="(files) => (fileList = files)"
          ></uploadfile>
        </template>
      </el-form-item>
      <el-form-item label="" prop="image" class="imgWrap">
        <template #label>
          图片 <span style="color: #999">(最多选择9张图片)</span
          ><uploadimg
            :loading.sync="form.loading"
            :fileListImg="fileListImg"
            @imgChange="(files) => (fileListImg = files)"
          ></uploadimg>
        </template>
      </el-form-item>
    </el-form>

    <template #footer>
      <el-row type="flex" justify="end">
        <el-button @click="toggle(false)">取消</el-button>
        <el-button
          type="primary"
          :loading.sync="form.loading"
          :disabled="form.loading"
          @click="submitForm"
          >完成</el-button
        >
      </el-row>
    </template>
  </el-dialog>
</template>

<script>
import { mixinTable } from "@/mixins/table.js";
import { getStorage } from "@/storage";
import uploadfile from "@/components/uploadfile.vue";
import uploadimg from "@/components/uploadimg.vue";
import aiTe from "@/components/aiTe.vue";
export default {
  name: "MyComment",
  mixins: [mixinTable],
  components: { uploadfile, uploadimg ,aiTe},
  data() {
    return {
      token: getStorage("token"),
      subUnitSize: this.$store.state.subUnitSize, // 获取组件 size属性
      visible: false,
      isChange: false,
      loading: false,
      form: {
        loading: false,
        data: {
          id: "",
          comment: "",
          picture: [],
          files: [],
        },
        rules: {},
      },
      fileList: [],
      fileListImg: [],
      aiteIdList:[],
      aiteObjList:[],
    };
  },
  methods: {
    tagClose(id) {
      this.aiteIdList = this.aiteIdList.filter((item) => item !== id);
      this.aiteObjList = this.aiteObjList.filter((item) => item.id !== id);
      this.$refs.aiTeRef.personObjList = this.aiteObjList;
    },
    aiTeChange(val) {
      this.aiteObjList = val;
      console.log('收到','aiteObjList',this.aiteObjList)
    },
    getDetail(row) {
      if (!!row.id) {
        this.isChange = true;
        this.$nextTick(() => {
          this.form.data.id = row.id;
        });
      }
    },
    reset(done) {
      this.isChange = false;
      this.fileList = [];
      this.fileListImg = [];
      this.aiteIdList = [],
      this.aiteObjList = [],
      this.$refs.elFormDom.resetFields();
      done && done();
    },
    toggle(show) {
      this.visible = show;
      !show && this.reset();
    },
    // 提交
    submitForm() {
      this.$refs.elFormDom.validate((valid) => {
        if (valid) {
          let _fileList = this.fileList.map((v) => {
            return {
              name: v.name,
              file: v.url,
            };
          });
          let _fileListImg = this.fileListImg.map((v) => v.url);
          if (
            _fileList.length == 0 &&
            _fileListImg.length == 0 &&
            this.form.data.comment == ""
          ) {
            return this.$message.warning("评论内容不能为空");
          }
          let at_employees = this.aiteObjList.length>0?this.aiteObjList.map(item => {
              return {
                employee_id:item.id,
                name:item.name
              }
          }):[];
          let _params = {
            id: this.form.data.id,
            comment: this.form.data.comment,
            picture: JSON.stringify(_fileListImg),
            files: JSON.stringify(_fileList),
            at_employees:JSON.stringify(at_employees)
          };
          if(at_employees.length) {
            let str = '';
            at_employees.forEach(e => {
              str += `@${e.name} `
            });
            _params.comment = str +' ' +this.form.data.comment;
          }
          this.form.loading = true;
          this.$http
            .post("/admin/employeeApproval/comment", _params)
            .then((res) => {
              if (res.code === 1) {
                this.toggle(false);
                this.$emit("refresh");
              }
            })
            .finally(() => {
              this.form.loading = false;
            });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.imgWrap ::v-deep .el-upload--picture-card {
  width: 80px !important;
  height: 80px !important;
  line-height: 80px !important;
}
.imgWrap ::v-deep .el-upload-list__item {
  width: 80px !important;
  height: 80px !important;
}
.imgWrap ::v-deep .avatar-uploader-icon {
  width: 80px !important;
  height: 80px !important;
  line-height: 80px !important;
}
.padding-b10{
  padding-bottom: 10px;
}
::v-deep .el-form-item__label {
  width: 100% !important;
}
</style>